import OpticksLink from "@/components/ui/OpticksLink/OpticksLink";
import OpticksNumberCircle from "@/components/ui/OpticksNumberCircle/OpticksNumberCircle";
import step_1_1 from "@/assets/integration-steps/taboola/step_1_1.png";
import step_1_2 from "@/assets/integration-steps/taboola/step_1_2.png";
import step_1_3 from "@/assets/integration-steps/taboola/step_1_3.png";
import step_1_4 from "@/assets/integration-steps/taboola/step_1_4.png";

interface Props {
  stepLabel?: string;
}

const TaboolaIntegrationStep2 = ({ stepLabel }: Props) => {
  return (
    <div className="channels-integration-step taboola-step-2">
      <div className="step-label-row">
        {stepLabel && <OpticksNumberCircle number={stepLabel} />}
        <h6>Create the exclusion audience in Taboola</h6>
      </div>
      <div className="wrapper">
        <p>
          Go to your{" "}
          <OpticksLink
            href="https://ads.taboola.com"
            label="Taboola Ads dashboard"
          />
          , navigate to the <b>Audiences</b> section (under Pixel Audiences) and
          click on <b>"+ New audience"</b> to start the audience creation
          process. Then select Pixel audience type.
        </p>
        <br />
        <img src={step_1_1} alt="Screenshot of step 1.1 Taboola Integration" />
        <br />
        <img src={step_1_2} alt="Screenshot of step 1.2 Taboola Integration" />
      </div>

      <div className="wrapper">
        <p>
          Give a descriptive name to your audience, e.g.{" "}
          <b>"Opticks Negative Audience"</b>, and set Event Name as{" "}
          <b>OpticksExcludeVisitor</b>
        </p>
        <br />
        <img src={step_1_3} alt="Screenshot of step 1.3 Taboola Integration" />
      </div>

      <div className="wrapper">
        <p>
          Under <b>Audience Properties</b>, set{" "}
          <b>"Exclude Audience From All Campaigns"</b> to <b>"Yes"</b>. This
          will automatically apply the exclusion to all your current and future
          campaigns, so you won't need to assign it manually to each one.
        </p>
        <br />
        <img src={step_1_4} alt="Screenshot of step 1.4 Taboola Integration" />
        <br />

        <p>
          This setting is also enabled by default for conversions of type{" "}
          <b>Lead</b>, <b>Complete Registration</b>, and <b>App Install</b>.
        </p>
        <p>
          <b>
            Once the exclusion is active, your campaigns will start filtering
            out invalid traffic detected by Opticks.
          </b>
        </p>
      </div>
    </div>
  );
};

export default TaboolaIntegrationStep2;
